<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <Pay
        formSlug="trademark-renewal"
        stepBack="step-5"
        @init="init"
    ></Pay>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import Pay from '@/components/Pay.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Pay
    },
    data() {
        return {
            classes: []
        }
    },
    mounted() {
        to_top()
    },
    methods: {
        init(data) {
            this.classes = data.classes
        }
    },
    computed: {
        countElements() {
            return this.classes.length ? 6 + (this.classes.length * 2) : 0
        }
    }
}
</script>
